import { createFileRoute } from "@tanstack/react-router";
import { PemakaianPage } from "@/components/admin/ai-assistant/pemakaian-page";
import { requireAdminFeature } from "@/middleware/admin-feature-guard";

export const Route = createFileRoute("/admin/ai-assistant/pemakaian")({
	beforeLoad: requireAdminFeature("admin-ai-pemakaian"),
	component: PemakaianPage,
});
